/**
 * Add a new category
 *
 * @param vars
 * @returns {boolean}
 */
function add_evaluation_category(vars) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/evaluations/categories/add/',
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit((data) => {
                $('body').doneLoading();

                reload_location_if_needed(true);
                squde_reload_for_flashes();

                if (vars && vars.callback) {
                    vars.callback(data);
                }
                if (!document.closeWindow) open_new_object(view_evaluation_category, data);
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * View the given category
 *
 * @param id
 * @param vars
 * @returns {boolean}
 */
function view_evaluation_category(id) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/evaluations/categories/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit((data) => {
                updateObject('evaluation-category', id);
                $('body').doneLoading();

                squde_reload_for_flashes();

                if (document.closeWindow) popup.close();
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
